/**
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
export default class ScaleUtil {
  static WeightValue(value) {
    switch (value.unit) {
      case 'kg':
        return value.num.toFixed(3) + value.unit;
      case 'g':
        return value.num.toFixed(0) + value.unit;
      default:
        return String(value.num) + value.unit;
    }
  }

  static toKg(value) {
    switch (value.unit) {
      case 'kg':
        return value.num;
      case 'g':
        return value.num / 1000;
      default:
        break;
    }
  }
}
